<script setup>
    import { getEnv } from '@/composables/helpers/getEnv'
    import { useGlobalStore } from '@/stores/global'
    import { updateGlobals } from '@/composables/data/updateGlobals'
    
    const { useSkin } = storeToRefs(useGlobalStore())

    await updateGlobals()

    const builderEnv = getEnv('builderEnv')
    const cleanEnv = builderEnv.toLowerCase().replace(/[^a-z0-9-]/g, '')
    
    useSkin.value = cleanEnv === 'architecturecruisecom'

</script>
<template>
    <div class="app-wrapper" :class="[cleanEnv,]">
        <NuxtRouteAnnouncer />
        <NuxtLayout />
    </div>
</template>

<style lang="scss">
    @import '@/assets/styles/main.scss';

    .app-wrapper {
        display: flex;
        min-height: 100vh;
        flex-direction: column;

        &.architecturecruisecom {
            --red: var(--first-lady-teal);

            .global-header {
                background-color: var(--first-lady-gold);

                .logo-container {
                    background: linear-gradient(180deg, #FFFAF0 0%, #F5E4C8 100%);
                    
                    &:before {
                        background: linear-gradient(180deg, #FFFAF0 0%, #F5E4C8 100%);
                    }
                }

                .menu-container {
                    background: linear-gradient(180deg, #FFFAF0 0%, #F5E4C8 100%);
                }
            }
        }
    }
</style>
